import { EventType } from "../../../../../common/enums";
import styles from "../EventItem.module.scss";

export const getGroupTypeIndicatorClass = (eventType?: EventType): string => {
  switch (eventType) {
    case EventType.Group:
      return styles.root_indicator_group;
    case EventType.Individual:
      return styles.root_indicator_individual;
    case EventType.Service:
      return styles.root_indicator_service;
    case EventType.BlockedTime:
      return styles.root_indicator_blocked;
    default:
      return styles.root_indicator_group;
  }
};
